import Button from "@shared/v2/Button";
import IconButton from "@shared/v2/IconButton";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import { XmarkSolidV6 } from "@shared/v2/Icomoon";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";

const TrainingResourceVideoModal: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const currentUser = useCurrentUser() as { account: { isAdmin: boolean } };

  return (
    <Modal
      show={open}
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="!tw-p-0 tw-max-w-[640px] tw-max-h-[90vh] tw-w-full"
    >
      <div className="tw-p-[56.25%_0_0_0] tw-relative tw-rounded-t-[6px] tw-overflow-hidden tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-[1px] tw-border-gray-10">
        <iframe
          src={`https://player.vimeo.com/video/${currentUser.account.isAdmin ? "1127691630" : "1127691619"}`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"
          title="Phone System - Agent"
        />
      </div>
      <div className="tw-px-[32px] tw-pt-[32px] tw-pb-[24px] tw-flex tw-flex-col tw-items-center tw-gap-[32px]">
        <div className="tw-w-full tw-flex tw-justify-between tw-items-center tw-gap-[16px]">
          {/* @ts-expect-error props */}
          <Typography className="!tw-text-gray-50">
            For tips, tricks, and best practices, visit the Brivity Knowledgebase
          </Typography>
          {/* @ts-expect-error props */}
          <Button
            schema="secondary"
            onClick={() =>
              window.open("https://www.brivityknowledge.com/docs/what-is-the-brivity-phone-system", "_blank")
            }
          >
            Learn More
          </Button>
        </div>
      </div>
      {/* @ts-expect-error props */}
      <IconButton
        schema="tertiary"
        size="small"
        className="tw-absolute tw-top-[16px] tw-right-[16px]"
        onClick={onClose}
      >
        <XmarkSolidV6 />
      </IconButton>
    </Modal>
  );
};

export default TrainingResourceVideoModal;
